/**
 * <hotel-date-bar> 顶层 React App(纯日期栏)
 *
 * 职责:用共享控制器解析酒店(loading/denied 返回 null + 宿主挂 hidden,denied 派发 hotelerror)、
 * 管理日期状态、渲染 DateBar(无动作按钮)。仅派发 datechange;不跳转、不派发 book。共享逻辑见 shared.ts。
 */
import { useDateBarController, type AppProps } from './shared';
import { DateBar } from './DateBar';

export function DateBarApp({ initialCheckIn, initialCheckOut, host }: AppProps) {
  const { hotel, dates, handleDateChange } = useDateBarController(
    host,
    initialCheckIn,
    initialCheckOut
  );

  // loading/denied 均不渲染(宿主 hidden 已占位处理由控制器 effect 完成)
  if (hotel !== 'ok') return null;

  return (
    <DateBar checkIn={dates.checkIn} checkOut={dates.checkOut} onDateChange={handleDateChange} />
  );
}
